/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.297
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BankAccountBaseAllBaseReadDictAllDictRead } from '../model/bankAccountBaseAllBaseReadDictAllDictRead';
// @ts-ignore
import { BankAccountBaseAllBaseWriteDictAllDictWrite } from '../model/bankAccountBaseAllBaseWriteDictAllDictWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface ApiBankAccountsGetCollectionBankAccountCollectionRequestParams {
    id?: string;
    id2?: Array<string>;
    name?: string;
    accountNumber?: string;
    accName?: string;
    orderId?: string;
    orderName?: string;
    orderAccountNumber?: string;
    orderAccName?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface ApiBankAccountsGetItemBankAccountItemRequestParams {
    id: string;
}

export interface ApiBankAccountsPatchItemBankAccountItemRequestParams {
    id: string;
    /** The updated BankAccount resource */
    bankAccount?: BankAccountBaseAllBaseWriteDictAllDictWrite;
}

export interface ApiBankAccountsPostCollectionBankAccountCollectionRequestParams {
    /** The new BankAccount resource */
    bankAccount?: BankAccountBaseAllBaseWriteDictAllDictWrite;
}

export interface ApiBankAccountsPutItemBankAccountItemRequestParams {
    id: string;
    /** The updated BankAccount resource */
    bankAccount?: BankAccountBaseAllBaseWriteDictAllDictWrite;
}


@Injectable({
  providedIn: 'root'
})
export class BankAccountService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Retrieves the collection of BankAccount resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBankAccountsGetCollectionBankAccountCollection(requestParameters?: ApiBankAccountsGetCollectionBankAccountCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsGetCollectionBankAccountCollection(requestParameters?: ApiBankAccountsGetCollectionBankAccountCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<BankAccountBaseAllBaseReadDictAllDictRead>>>;
    public apiBankAccountsGetCollectionBankAccountCollection(requestParameters?: ApiBankAccountsGetCollectionBankAccountCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<BankAccountBaseAllBaseReadDictAllDictRead>>>;
    public apiBankAccountsGetCollectionBankAccountCollection(requestParameters?: ApiBankAccountsGetCollectionBankAccountCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        const id2 = requestParameters?.id2;
        const name = requestParameters?.name;
        const accountNumber = requestParameters?.accountNumber;
        const accName = requestParameters?.accName;
        const orderId = requestParameters?.orderId;
        const orderName = requestParameters?.orderName;
        const orderAccountNumber = requestParameters?.orderAccountNumber;
        const orderAccName = requestParameters?.orderAccName;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (id2) {
            id2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'id[]');
            })
        }
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }
        if (accountNumber !== undefined && accountNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>accountNumber, 'accountNumber');
        }
        if (accName !== undefined && accName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>accName, 'accName');
        }
        if (orderId !== undefined && orderId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderId, 'order[id]');
        }
        if (orderName !== undefined && orderName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderName, 'order[name]');
        }
        if (orderAccountNumber !== undefined && orderAccountNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderAccountNumber, 'order[accountNumber]');
        }
        if (orderAccName !== undefined && orderAccName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderAccName, 'order[accName]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/bank_accounts`;
        return this.httpClient.request<Array<BankAccountBaseAllBaseReadDictAllDictRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a BankAccount resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBankAccountsGetItemBankAccountItem(requestParameters?: ApiBankAccountsGetItemBankAccountItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<BankAccountBaseAllBaseReadDictAllDictRead>;
    public apiBankAccountsGetItemBankAccountItem(requestParameters?: ApiBankAccountsGetItemBankAccountItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsGetItemBankAccountItem(requestParameters?: ApiBankAccountsGetItemBankAccountItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsGetItemBankAccountItem(requestParameters?: ApiBankAccountsGetItemBankAccountItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiBankAccountsGetItemBankAccountItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/bank_accounts/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<BankAccountBaseAllBaseReadDictAllDictRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the BankAccount resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBankAccountsPatchItemBankAccountItem(requestParameters?: ApiBankAccountsPatchItemBankAccountItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<BankAccountBaseAllBaseReadDictAllDictRead>;
    public apiBankAccountsPatchItemBankAccountItem(requestParameters?: ApiBankAccountsPatchItemBankAccountItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsPatchItemBankAccountItem(requestParameters?: ApiBankAccountsPatchItemBankAccountItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsPatchItemBankAccountItem(requestParameters?: ApiBankAccountsPatchItemBankAccountItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiBankAccountsPatchItemBankAccountItem.');
        }
        const bankAccount = requestParameters?.bankAccount;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/bank_accounts/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<BankAccountBaseAllBaseReadDictAllDictRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bankAccount,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a BankAccount resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBankAccountsPostCollectionBankAccountCollection(requestParameters?: ApiBankAccountsPostCollectionBankAccountCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<BankAccountBaseAllBaseReadDictAllDictRead>;
    public apiBankAccountsPostCollectionBankAccountCollection(requestParameters?: ApiBankAccountsPostCollectionBankAccountCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsPostCollectionBankAccountCollection(requestParameters?: ApiBankAccountsPostCollectionBankAccountCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsPostCollectionBankAccountCollection(requestParameters?: ApiBankAccountsPostCollectionBankAccountCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const bankAccount = requestParameters?.bankAccount;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/bank_accounts`;
        return this.httpClient.request<BankAccountBaseAllBaseReadDictAllDictRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bankAccount,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replaces the BankAccount resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBankAccountsPutItemBankAccountItem(requestParameters?: ApiBankAccountsPutItemBankAccountItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<BankAccountBaseAllBaseReadDictAllDictRead>;
    public apiBankAccountsPutItemBankAccountItem(requestParameters?: ApiBankAccountsPutItemBankAccountItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsPutItemBankAccountItem(requestParameters?: ApiBankAccountsPutItemBankAccountItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<BankAccountBaseAllBaseReadDictAllDictRead>>;
    public apiBankAccountsPutItemBankAccountItem(requestParameters?: ApiBankAccountsPutItemBankAccountItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiBankAccountsPutItemBankAccountItem.');
        }
        const bankAccount = requestParameters?.bankAccount;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/bank_accounts/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<BankAccountBaseAllBaseReadDictAllDictRead>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bankAccount,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
